import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core'
import { AdminService } from '../../services/admin.service'
import { AuthenticationService } from '../../services/authentication.service'
import { Router } from '@angular/router'

import { RouterModule } from '@angular/router'
import { FirstwordPipe } from './firstword.pipe'

@Component({
    selector: 'app-topbar',
    templateUrl: './topbar.component.html',
    styleUrls: ['./topbar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterModule, FirstwordPipe]
})
export class TopbarComponent implements OnInit {
  details

  ngOnInit () {
    this.getDetails()
  }
  constructor (
    private adminService: AdminService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  getDetails () {
    this.adminService.getDetails().subscribe(data => {
      this.details = data[0]
      try {
        this.cdr.detectChanges();
      } catch (e) { void e; }
      this.checkPage()
    })
  }

  checkPage () {
    if (this.details.permission === 'admin') {
      const page = this.router.url
      // console.log(page);
      const adminOnly = ['/agent', '/admin']
      const superAdminOnly = ['/reconciliation']
      if (adminOnly.indexOf(page) !== -1 || superAdminOnly.indexOf(page) !== -1) {
        this.router.navigate(['dashboard'])
      }
    }
  }

  logout (event) {
    event.preventDefault()
    this.authenticationService.logout()
  }
}
